module.exports = __webpack_public_path__ + "static/media/arrow-next.38e116b2.svg";